<div class="map-controls-container">
	<!-- Oben links: Zoom, Selection -->
	<div class="controls-top-left" [class.compact]="compact" [class.ultra-compact]="ultraCompact">
		<!-- Zoom +/- -->
		<div class="control-group zoom-group">
			<button class="ctrl-btn" title="Vergrößern" (click)="onZoomIn()">
				<i class="bi bi-plus-lg"></i>
			</button>
			<button class="ctrl-btn" title="Verkleinern" (click)="onZoomOut()">
				<i class="bi bi-dash-lg"></i>
			</button>
			<span class="zoom-level" [title]="'Zoomstufe ' + zoomLevel">{{ zoomLevel | number:'1.0-1' }}</span>
		</div>

		<!-- Zoom-To Controls (expandierbar) -->
		<div class="control-group">
			<div class="expandable-group" [class.expanded]="zoomToExpanded">
				<button class="ctrl-btn" title="Zoom zu..." (click)="toggleZoomToExpanded()"
					[class.active]="zoomToWindowActive" [disabled]="isGpsTrackingActive()">
					<i class="bi bi-search"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Neu zentrieren (GPS)" (click)="onGpsHome()"
					*ngIf="zoomToExpanded">
					<i class="bi bi-geo-fill"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Auf Bearbeitungsbereich zoomen" (click)="onFitBounds()"
					*ngIf="zoomToExpanded">
					<i class="bi bi-house"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Auf Auswahl zoomen" (click)="onZoomToSelection()"
					[disabled]="selectionCount === 0" *ngIf="zoomToExpanded">
					<i class="bi bi-check2-square"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Auf Filter zoomen" (click)="onZoomToFilter()"
					[disabled]="filteredCount === 0" *ngIf="zoomToExpanded">
					<i class="bi bi-funnel"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Zoom aufziehen" (click)="onZoomToWindow()"
					[class.active]="zoomToWindowActive" *ngIf="zoomToExpanded">
					<i class="bi bi-aspect-ratio"></i>
				</button>
			</div>
		</div>

		<!-- Selection Controls + Actions in einer Gruppe -->
		<div class="control-group">
			<!-- Auswahl-Gruppe (expandierbar) -->
			<div class="expandable-group" [class.expanded]="selectionExpanded">
				<button class="ctrl-btn" title="Auswahl" (click)="toggleSelectionExpanded()"
					[class.active]="selectionMode !== 'none'" [disabled]="isGpsTrackingActive()">
					<img src="assets/img/selection.svg" class="custom-icon" alt="Auswahl">
				</button>
				<button class="ctrl-btn expand-btn" title="Rechteck-Auswahl" (click)="onRectangleSelection()"
					[class.active]="selectionMode === 'rectangle'" *ngIf="selectionExpanded">
					<i class="bi bi-square"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Polygon-Auswahl" (click)="onPolygonSelection()"
					[class.active]="selectionMode === 'polygon'" *ngIf="selectionExpanded">
					<i class="bi bi-pentagon"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Freihand-Auswahl" (click)="onFreehandSelection()"
					[class.active]="selectionMode === 'freehand'" *ngIf="selectionExpanded">
					<img src="assets/img/draw-polygon-freehand.svg" class="custom-icon" alt="Freihand">
				</button>
				<button class="ctrl-btn expand-btn" title="Gefilterte Punkte auswählen" (click)="selectFiltered.emit()"
					*ngIf="selectionExpanded && filteredCount > 0">
					<i class="bi bi-funnel"></i>
				</button>
				<button class="ctrl-btn expand-btn btn-success" title="Polygon abschließen" (click)="finishPolygon.emit()"
					*ngIf="selectionMode === 'polygon' && polygonPoints >= 3">
					<i class="bi bi-check-lg"></i>
				</button>
				<button class="ctrl-btn expand-btn btn-danger" title="Auswahl aufheben" (click)="clearSelection.emit()"
					*ngIf="selectionExpanded && selectionCount > 0">
					<i class="bi bi-x-lg"></i>
				</button>
			</div>
		</div>

		<!-- Pan-Modus - alle Werkzeuge abwählen -->
		<div class="control-group">
			<button class="ctrl-btn" title="Navigieren (Pan/Zoom)" (click)="onDeactivateAllTools()"
				[class.active]="!isAnyToolActive()" [disabled]="isGpsTrackingActive()">
				<i class="bi bi-hand-index-thumb"></i>
			</button>
		</div>

		<!-- WMS Info Tool -->
		<div class="control-group" *ngIf="hasVisibleWmsLayers">
			<button class="ctrl-btn" title="Layer-Info: Klick zeigt Informationen zum Objekt"
				(click)="toggleWmsInfo.emit()"
				[class.active]="wmsInfoActive"
				[disabled]="isGpsTrackingActive()">
				<i class="bi bi-info-circle"></i>
			</button>
		</div>
	</div>

	<!-- Unten links: New Point, Draw -->
	<div class="controls-bottom-left" [class.compact]="compact" [class.ultra-compact]="ultraCompact">
		<!-- Draw Controls (inkl. Punkt) -->
		<div class="control-group draw-controls" *ngIf="showDrawControls || canCreatePoint">
			<!-- Punkt-Gruppe -->
			<div class="expandable-group" [class.expanded]="pointExpanded" [class.disabled]="!canCreatePointAndNetwork || isGpsTrackingActive()">
				<button class="ctrl-btn"
					[disabled]="!canCreatePointAndNetwork || isGpsTrackingActive()"
					[ngbTooltip]="!canCreatePoint ? 'Keine Berechtigung zum Anlegen von Punkten' : (!networkAvailable ? networkHint : 'Neuer Punkt')"
					(click)="canCreatePointAndNetwork && !isGpsTrackingActive() && togglePointExpanded()"
					[class.active]="newPointOnMapActive">
					<img src="assets/img/draw-point.svg" class="custom-icon" alt="Punkt">
				</button>
				<button class="ctrl-btn expand-btn"
					ngbTooltip="Neuer Punkt am aktuellen Standort"
					(click)="onPointAtLocation()"
					*ngIf="pointExpanded">
					<i class="bi bi-geo-alt-fill"></i>
				</button>
				<button class="ctrl-btn expand-btn"
					ngbTooltip="Neuer Punkt (Klick auf Karte)"
					(click)="onPointOnMap()"
					[class.active]="newPointOnMapActive"
					*ngIf="pointExpanded">
					<i class="bi bi-circle"></i>
				</button>
			</div>

			<!-- Polygon-Gruppe -->
			<div class="expandable-group" [class.expanded]="polygonExpanded || isPolygonToolActive()" [class.disabled]="!canDrawAndNetwork" *ngIf="showDrawControls">
				<button class="ctrl-btn" [title]="getDisabledHint(true) || 'Polygon zeichnen'" (click)="canDrawAndNetwork && togglePolygonExpanded()"
					[class.active]="isPolygonToolActive()" [disabled]="!canDrawAndNetwork || (isGpsTrackingActive() && !gpsTrackingPolygonEnabled)">
					<img src="assets/img/draw-polygon.svg" class="custom-icon" alt="Polygon">
				</button>
				<button class="ctrl-btn expand-btn" title="Polygon aus Knotenpunkten" (click)="onPolygonNodes()"
					[class.active]="drawEnabled" [disabled]="!canDrawAndNetwork || isGpsTrackingActive()"
					*ngIf="(polygonExpanded || isPolygonToolActive()) && !gpsTrackingPolygonEnabled">
					<img src="assets/img/draw-polygon-nodes.svg" class="custom-icon" alt="Knoten">
				</button>
				<button class="ctrl-btn expand-btn" title="Polygon Freihand" (click)="onPolygonFreehand()"
					[class.active]="freehandEnabled" [disabled]="!canDrawAndNetwork || isGpsTrackingActive()"
					*ngIf="(polygonExpanded || isPolygonToolActive()) && !gpsTrackingPolygonEnabled">
					<img src="assets/img/draw-polygon-freehand.svg" class="custom-icon" alt="Freihand">
				</button>
				<button class="ctrl-btn expand-btn" title="Polygon per GPS-Tracking" (click)="onPolygonGpsTracking()"
					[class.active]="gpsTrackingPolygonEnabled" [class.pulse]="gpsTrackingPolygonEnabled"
					[disabled]="!canDrawAndNetwork"
					*ngIf="(polygonExpanded || isPolygonToolActive()) && !gpsTrackingPolygonEnabled">
					<img src="assets/img/footprint.svg" class="custom-icon" alt="GPS-Tracking">
				</button>
				<!-- GPS-Tracking aktiv: Pulsierender Button + Stop -->
				<button class="ctrl-btn expand-btn pulse" title="GPS-Tracking läuft..."
					*ngIf="gpsTrackingPolygonEnabled">
					<img src="assets/img/footprint.svg" class="custom-icon" alt="GPS-Tracking">
				</button>
				<button class="ctrl-btn expand-btn btn-danger" title="GPS-Tracking stoppen" (click)="onStopGpsTracking()"
					*ngIf="gpsTrackingPolygonEnabled">
					<i class="bi bi-stop-fill"></i>
				</button>
				<button class="ctrl-btn expand-btn btn-success" title="Polygon abschließen" (click)="finishDrawPolygon.emit()"
					*ngIf="drawEnabled && drawPolygonPoints >= 3">
					<i class="bi bi-check-lg"></i>
				</button>
				<button class="ctrl-btn expand-btn btn-success" title="Zeichnen beenden" (click)="finishDrawMode.emit()"
					*ngIf="isPolygonToolActive() && hasDrawnPolygon && !isGpsTrackingActive()">
					<i class="bi bi-check-lg"></i>
				</button>
			</div>

			<!-- Linien-Gruppe -->
			<div class="expandable-group" [class.expanded]="lineExpanded || isLineToolActive()" [class.disabled]="!canDrawAndNetwork" *ngIf="showDrawControls">
				<button class="ctrl-btn" [title]="getDisabledHint(true) || 'Linie zeichnen'" (click)="canDrawAndNetwork && toggleLineExpanded()"
					[class.active]="isLineToolActive()" [disabled]="!canDrawAndNetwork || (isGpsTrackingActive() && !gpsTrackingLineEnabled)">
					<img src="assets/img/draw-line.svg" class="custom-icon" alt="Linie">
				</button>
				<button class="ctrl-btn expand-btn" title="Linie aus Knotenpunkten" (click)="onLineNodes()"
					[class.active]="lineEnabled" [disabled]="!canDrawAndNetwork || isGpsTrackingActive()"
					*ngIf="(lineExpanded || isLineToolActive()) && !gpsTrackingLineEnabled">
					<img src="assets/img/draw-line-nodes.svg" class="custom-icon" alt="Knoten">
				</button>
				<button class="ctrl-btn expand-btn" title="Linie Freihand" (click)="onLineFreehand()"
					[class.active]="lineFreehandEnabled" [disabled]="!canDrawAndNetwork || isGpsTrackingActive()"
					*ngIf="(lineExpanded || isLineToolActive()) && !gpsTrackingLineEnabled">
					<img src="assets/img/draw-line-freehand.svg" class="custom-icon" alt="Freihand">
				</button>
				<button class="ctrl-btn expand-btn" title="Linie per GPS-Tracking" (click)="onLineGpsTracking()"
					[class.active]="gpsTrackingLineEnabled" [class.pulse]="gpsTrackingLineEnabled"
					[disabled]="!canDrawAndNetwork"
					*ngIf="(lineExpanded || isLineToolActive()) && !gpsTrackingLineEnabled">
					<img src="assets/img/footprint.svg" class="custom-icon" alt="GPS-Tracking">
				</button>
				<!-- GPS-Tracking aktiv: Pulsierender Button + Stop -->
				<button class="ctrl-btn expand-btn pulse" title="GPS-Tracking läuft..."
					*ngIf="gpsTrackingLineEnabled">
					<img src="assets/img/footprint.svg" class="custom-icon" alt="GPS-Tracking">
				</button>
				<button class="ctrl-btn expand-btn btn-danger" title="GPS-Tracking stoppen" (click)="onStopGpsTracking()"
					*ngIf="gpsTrackingLineEnabled">
					<i class="bi bi-stop-fill"></i>
				</button>
				<button class="ctrl-btn expand-btn btn-success" title="Zeichnen beenden" (click)="finishDrawMode.emit()"
					*ngIf="isLineToolActive() && hasDrawnLine && !isGpsTrackingActive()">
					<i class="bi bi-check-lg"></i>
				</button>
			</div>

			<!-- Edit/Delete -->
			<div class="expandable-group" [class.disabled]="!canDrawAndNetwork" *ngIf="showDrawControls">
				<button class="ctrl-btn" [title]="getDisabledHint(true) || 'Bearbeiten'" (click)="canDrawAndNetwork && onEditDraw()"
					[class.active]="editEnabled" [disabled]="!canDrawAndNetwork || isGpsTrackingActive()">
					<img src="assets/img/draw-edit.svg" class="custom-icon" alt="Bearbeiten">
				</button>
				<!-- Abschließen-Button erscheint neben Schraubenschlüssel wenn aktiv -->
				<button class="ctrl-btn expand-btn btn-success" title="Änderungen übernehmen" (click)="confirmEdit.emit()"
					*ngIf="editEnabled">
					<i class="bi bi-check-lg"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Abbrechen" (click)="cancelEdit.emit()"
					*ngIf="editEnabled">
					<i class="bi bi-x-lg"></i>
				</button>
			</div>
			<div class="expandable-group" [class.disabled]="!canDrawAndNetwork" *ngIf="showDrawControls">
				<button class="ctrl-btn" [title]="getDisabledHint(true) || 'Löschen'" (click)="canDrawAndNetwork && onDeleteDraw()"
					[class.active]="deleteEnabled" [class.btn-danger]="!deleteEnabled" [disabled]="!canDrawAndNetwork || isGpsTrackingActive()">
					<img src="assets/img/draw-delete.svg" class="custom-icon" alt="Löschen">
				</button>
				<!-- Abschließen-Button erscheint neben Radierer wenn aktiv -->
				<button class="ctrl-btn expand-btn btn-success" title="Löschen übernehmen" (click)="confirmEdit.emit()"
					*ngIf="deleteEnabled">
					<i class="bi bi-check-lg"></i>
				</button>
				<button class="ctrl-btn expand-btn" title="Abbrechen" (click)="cancelEdit.emit()"
					*ngIf="deleteEnabled">
					<i class="bi bi-x-lg"></i>
				</button>
			</div>

		</div>
	</div>
</div>
